import type { ComponentType, SVGProps } from 'react';
import { ICON_MAP } from '@components/Icons/Icons';

export type SvgIcon = ComponentType<SVGProps<SVGSVGElement>>;

export const segmentManagerIcons = {
  Undo: ICON_MAP.undo,
  Redo: ICON_MAP.redo,
  Brush: ICON_MAP.brush,
  Eraser: ICON_MAP.eraser,
  Edit: ICON_MAP.edit,
  Sculpt: ICON_MAP.sculpt,
  Show: ICON_MAP.show,
  Hide: ICON_MAP.hide,
  Crop: ICON_MAP.crop,
  Dilate: ICON_MAP.dilate,
  Erode: ICON_MAP.erode,
  check: ICON_MAP.check,
  circleCheck: ICON_MAP.circleCheck,
  close: ICON_MAP.close2,
} satisfies Record<string, SvgIcon>;

export type SegmentManagerIcons = typeof segmentManagerIcons;
